<template>
  <div>
    <a-breadcrumb>
      <a-breadcrumb-item>系统设置</a-breadcrumb-item>
      <a-breadcrumb-item>项目文档类型管理</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="space-20">
      <a-button type="primary" @click="showModel = 'addType'">新增</a-button>
    </div>
    <a-table :loading="loading" :columns="columns" :dataSource="list" :rowKey="row => row.id">
      <span slot="status" slot-scope="status">{{ DOCUMENT_TYPE_STATUS(status) }}</span>
      <span slot="action" slot-scope="row" class="add-subType">
        <div v-if="!row.isSubType">
          <a-button @click="addSubType(row)" size="small">新建</a-button>
          <a-divider type="vertical" />
        </div>
        <a-button @click="editFileType(row)" size="small">编辑</a-button>
        <a-divider type="vertical" />
        <a-button @click="handleOpeartType(row)" size="small" :type="row.status == 0 ? 'danger' : 'primary'">{{ row.status == 0 ? '禁用' : '启用' }}</a-button>
      </span>
    </a-table>
    <a-modal title="新增文件类型" @cancel="closeModel" :visible="showModel == 'addType'" width="400px">
      <a-form>
        <a-form-item label="类型名称：" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
          <a-input v-model="typeInfo.name" placeholder="类型名称"></a-input>
        </a-form-item>
        <a-form-item label="备注：" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
          <a-input v-model="typeInfo.comment" placeholder="备注"></a-input>
        </a-form-item>
        <a-form-item label="排序：" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
          <a-input-number v-model="typeInfo.sort" />
        </a-form-item>
        <a-form-item label="状态：" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
          <a-radio-group v-model="typeInfo.status" defaultValue="1" buttonStyle="solid">
            <a-radio-button :value="0">启用</a-radio-button>
            <a-radio-button :value="-1">禁用</a-radio-button>
          </a-radio-group>
        </a-form-item>
      </a-form>
      <template slot="footer">
        <a-button @click="closeModel">取消</a-button>
        <a-button type="primary" @click="handleItem('add')">确定</a-button>
      </template>
    </a-modal>
    <a-modal title="编辑文件类型" @cancel="closeModel" :visible="showModel == 'editType'" width="400px">
      <a-form>
        <a-form-item label="类型名称：" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
          <a-input v-model="currentRow.name" placeholder="类型名称"></a-input>
        </a-form-item>
        <a-form-item label="备注：" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
          <a-input v-model="currentRow.comment" placeholder="备注"></a-input>
        </a-form-item>
        <a-form-item label="排序：" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
          <a-input-number v-model="currentRow.sort" />
        </a-form-item>
      </a-form>
      <template slot="footer">
        <a-button @click="closeModel">取消</a-button>
        <a-button type="primary" @click="handleItem('edit')">确定</a-button>
      </template>
    </a-modal>
    <a-modal :title="title" @cancel="closeModel" @ok="handleSubType(showModel)" :visible="showModel == 'addSubType' || showModel == 'editSubType'">
      <a-form-model
        :model="addSubTypeForm"
        ref="addSubTypeForm"
        :label-col="{ span: 6, offset: 1 }"
        :wrapper-col="{ span: 14 }"
        class="add-subType-modal"
        :rules="rules"
      >
        <a-form-model-item label="一级类型名称" prop="parentName"> <a-input v-model="addSubTypeForm.parentName" :disabled="true"/></a-form-model-item>
        <a-form-model-item label="二级类型名称" prop="name"> <a-input v-model="addSubTypeForm.name"/></a-form-model-item>
        <a-form-model-item label="备注"> <a-input v-model="addSubTypeForm.comment"/></a-form-model-item>
        <a-form-item label="状态：">
          <a-radio-group v-model="addSubTypeForm.status" defaultValue="1" buttonStyle="solid">
            <a-radio-button :value="0">启用</a-radio-button>
            <a-radio-button :value="-1">禁用</a-radio-button>
          </a-radio-group>
        </a-form-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
import { documentTypeList, documentTypeAction, documentTypeShowOrHide, addSubFile, editSubFile } from '@/api/document.js';
import { DOCUMENT_TYPE_STATUS } from '@/const/common.js';
const columns = [
  { title: '文档类型', dataIndex: 'name' },
  { title: '备注', dataIndex: 'comment' },
  { title: '状态', dataIndex: 'status', align: 'center', scopedSlots: { customRender: 'status' } },
  { title: 'RankScore', dataIndex: 'sort', align: 'center' },
  { title: '操作', align: 'center', scopedSlots: { customRender: 'action' } }
];
export default {
  data() {
    return {
      loading: true,
      columns,
      list: [],
      currentRow: {},
      showModel: '',
      typeInfo: {
        name: '',
        comment: '',
        sort: 0,
        status: 0
      },
      addSubTypeForm: {},
      title: '',
      rules: {
        name: [{ validator: this.validateType, trigger: 'blur' }]
      },
      fileTypeNameMap: {},
      currentSubName: ''
    };
  },
  methods: {
    DOCUMENT_TYPE_STATUS,
    closeModel() {
      this.showModel = '';
      if (this.$refs.addSubTypeForm) {
        let form = this.$refs.addSubTypeForm;
        form.resetFields();
      }
    },
    getList() {
      this.loading = true;
      documentTypeList().then(res => {
        this.list = res.data.map(_ => {
          if (_.subFiletypes) {
            return {
              ..._,
              children: _.subFiletypes
            };
          }
          return _;
        });
        this.list.forEach(_ => {
          // this.fileTypeNameList.push(_.name);
          if (_.children) {
            this.fileTypeNameMap[_.id] = [];
            _.children.forEach(e => {
              e.isSubType = true;
              e.parentName = _.name;
              e.sort = '-';
              this.fileTypeNameMap[_.id].push(e.name);
            });
          }
          _.isSubType = false;
        });
        this.loading = false;
      });
    },
    handleOpeartType(row) {
      let action = row.status === 0 ? 'forbidden' : 'recover';
      let type = row.isSubType ? 'fileSubType' : 'fileType';
      if (action === 'forbidden') {
        this.$confirm({
          title: `确定隐藏文件类型：${row.name}吗`,
          okText: '确定',
          okType: 'danger',
          cancelText: '取消',
          onOk: () => {
            documentTypeShowOrHide({ id: row.id, action, type }).then(res => {
              if (res.code === 200) {
                this.$message.success(res.data);
                this.getList();
              }
            });
          }
        });
      } else if (action === 'recover') {
        documentTypeShowOrHide({ id: row.id, action, type }).then(res => {
          if (res.code === 200) {
            this.$message.success(res.data);
            this.getList();
          }
        });
      }
    },
    handleItem(type) {
      let data = Object.assign({}, this.typeInfo);
      if (type === 'edit') {
        data.name = this.currentRow.name;
        data.comment = this.currentRow.comment;
        data.status = this.currentRow.status;
        (data.id = parseInt(this.currentRow.id)), (data.sort = this.currentRow.sort);
      }
      documentTypeAction(data).then(res => {
        if (res.code === 200) {
          this.closeModel();
          this.getList();
          this.$message.success(res.data || 'success');
          !data.id && (this.typeInfo = { name: '', comment: '', status: 0 });
        }
      });
    },
    addSubType(row) {
      this.showModel = 'addSubType';
      this.title = '新建二级文件类型';
      this.addSubTypeForm = {
        typeId: row.id,
        parentName: row.name,
        name: '',
        comment: '',
        status: 0
      };
    },
    async handleSubType(type) {
      try {
        let data = Object.assign({}, this.addSubTypeForm);
        let res;
        if (type === 'addSubType') {
          if (data.parentName) {
            delete data.parentName;
          }
          res = await addSubFile(data);
        } else if (type === 'editSubType') {
          if (data.parentName) {
            delete data.parentName;
          }
          if (data.typeId) {
            delete data.typeId;
          }
          res = await editSubFile(data);
        }
        if (res.code === 200) {
          this.$message.success('success');
          this.closeModel();
          this.getList();
          this.addSubTypeForm = {};
          this.currentSubName = '';
        }
      } catch (err) {
        console.log(err);
      }
    },
    editFileType(row) {
      if (row.isSubType) {
        this.showModel = 'editSubType';
        this.title = '编辑二级文件类型';
        this.addSubTypeForm = {
          id: row.id,
          parentName: row.parentName,
          name: row.name,
          comment: row.comment,
          status: row.status,
          typeId: row.typeId
        };
        this.currentSubName = row.name;
      } else {
        this.currentRow = row;
        this.showModel = 'editType';
      }
    },
    validateType(rule, value, callback) {
      let addSubTypeForm = this.addSubTypeForm;
      if (value === '') {
        callback(new Error('请输入二级文件类型名称'));
      } else if (
        this.fileTypeNameMap[addSubTypeForm.typeId] &&
        this.fileTypeNameMap[addSubTypeForm.typeId].find(_ => _ === value) &&
        value !== this.currentSubName
      ) {
        callback(new Error('当前二级文件类型名称已存在，请重新输入!'));
      } else {
        callback();
      }
    }
  },
  mounted() {
    this.getList();
  }
};
</script>

<style scoped>
.add-subType {
  display: flex;
  justify-content: center;
}
</style>
